export default __webpack_public_path__ + "images/e7b9d10a77d1d3e0c3e408a2608c8c3d.svg";